import React, { Component, useState, useEffect, useContext } from 'react'

import ResizeDetector from 'react-resize-detector'

import { NavigationContext } from './NavigationController'
import SplitView from './SplitView'

import { useWindowSize } from '../utilities/useWindowSize'

import { withStyles, makeStyles, createStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListSubheader from '@material-ui/core/ListSubheader'
import Divider from '@material-ui/core/Divider'

const styles = theme => ({
  root: {
    display: 'flex',
    direction: 'row'    
  },
  leftPane: {
    minWidth: 240,
    width: '20%',
  },
  leftPaneContainer: {
    position: 'fixed',
    overflow: 'auto',
    // borderRight: 'solid 1px #eee',
  },  
  listView: {
    width: '100%',
    paddingTop: theme.spacing(2)
  },
  listItemView: {
    width: '100%',
  },
  contentPane: {
    flexGrow: 1,
    overflow: 'hidden'
  },
  icon: {
    fontSize: '1.8rem',
    color: '#aaa',
  },
  selectedIcon: {
    fontSize: '1.8rem',
    color: theme.palette.primary.main
  },
  text: {
    fontWeight: 400,
    color: '#444',      
  },
  selectedText: {
    fontWeight: 700,
    color: '#000',
  }
})

const useStyles = makeStyles((theme: Theme) => createStyles(styles(theme)))

export const MenuItem = ({selected, ...props}) => {
  const classes = useStyles()
  
  const icon = props.icon && React.createElement(props.icon, 
    {
      className: selected ? classes.selectedIcon : classes.icon,
    })    
  
  return (
    <ListItem 
      button
      alignItems="flex-start" 
      className={classes.listItemView}
      {...props}
      >
      
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ marginRight: 8, display: 'flex', alignItems: 'center' }}>
          { icon }
        </div>
        <ListItemText
          primary={ 
            <span className={ selected ? classes.selectedText : classes.text }>
            { props.primaryText }
            </span>
          }
          secondary={ props.secondaryText }
        />
      </div>    
    </ListItem>
  )
}

export const MenuSection = (props) => {
  const classes = useStyles()  

  return (
    <>
      <ListSubheader>{ props.text }</ListSubheader>
      { props.children }
    </>
  )
}

const MenuView = ({ theme, classes, children, ...props }) => {

  return (
    <List className={classes.listView}>
      { children }      
    </List>
  )
}

const SplitMenuController = ({ theme, classes, children, content, onHideContent, ...props }) => {
  
  const navigationContext = useContext(NavigationContext)  

  const menuView = (
    <MenuView theme={theme} classes={classes}>
      { children }
    </MenuView>
  )
  
  const [windowWidth, windowHeight] = useWindowSize()

  let leftPaneContainerStyle={}
  if (!navigationContext.fitToWindow)
    leftPaneContainerStyle = {
      position: 'fixed',
      top: navigationContext.contentInset.top + 'px',
      height: windowHeight - navigationContext.contentInset.top + 'px',
      // width: '100%'
    }
    
  return (
    <div className={classes.root}>
      <div className={classes.leftPane}>
        <ResizeDetector
          handleWidth
          render={({ width }) => (
            <div className={classes.leftPaneContainer}
              style={{ 
                  width: width, 
                  position: 'absolute',
                  ...leftPaneContainerStyle
                }}
              >
              { menuView }
            </div>
          )}
        />        
      </div>
      <div className={classes.contentPane}>
        { content }
      </div>
    </div>
  )
}

export default withStyles(styles, { withTheme: true })(SplitMenuController)  

